<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/blogs",
		    "name": "Blogs"
		  }
		},{
            "@type": "ListItem",
            "position": 3,
            "item": {
              "@id": "https://www.protectt.ai/protecting-sensitive-mobile-apps-on-rooted-device",
              "name": "Comply with National Payments Corporation of India’s (NPCI’s) latest master circular for Device and SIM Binding"
            }
          }		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li><a routerLink="/blogs">Blogs</a></li>
                    <li>></li>
                    <li>Comply with National Payments Corporation of India’s (NPCI’s) latest master circular for Device and SIM Binding</li>
                </ul>
            </div>
        </div>
    </div>
</div>


<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
                    <h1 id="bnr-heading">{{heading}}</h1>
                    <h2 id="bnr-subheading">{{subheading}}</h2>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                    <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
            </div>
        </div>
    </div>
</div>

<!--// Breadcrumb -->

<script type="application/ld+json">
    {
      "@context": "https://schema.org/",
      "@type": "Article",
      "name": "Device and SIM Binding",
      "description": "Comply with National Payments Corporation of India’s (NPCI’s) latest master circular for Device and SIM Binding." 
    } 
    </script>


<!-- Page Conttent -->
<main class="page-content">

    <!-- content-wraper start -->
    <div class="content-wraper section-pb section">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 order-2 order-lg-2">
                    <!-- blog-widget-wrap start -->
                    <app-blog-sidebar></app-blog-sidebar>
                    <!-- blog-widget-wrap end -->
                </div>

                <div class="col-lg-9 order-1 order-lg-1">
                    <!-- blog-details-wrapper start -->
                    <div class="blog-details-wrapper mt-30">
                        <div class="postinfo-wrapper">
                            <div class="post-info">

                                <h3 style="font-weight:700; ">Comply with National Payments Corporation of India’s (NPCI’s) latest master circular for Device and SIM Binding.</h3>
                                <img src="../../../assets/images/blog/deviceandsimbinding.jpeg" class="og_image_url"
                                    alt="Comply with National Payments Corporation of India’s (NPCI’s) latest master circular for Device and SIM Binding">
                                <h3 class="mt-30px">Mitigate Identity Theft & Frauds for Banking & Financial Mobile Apps</h3>
                                <p>
                                    In recent years, Unified Payments Interface (UPI) has transformed digital payment ecosystem and has emerged as a 
                                    preferred mode of financial transactions. 
                                    UPI has clocked monthly 11.24 billion transactions worth Rs. 17.16 Lakh Crore Rupees.  
                                    Mobile financial fraud has become a lucrative business for fraudsters due to the increase in the use of UPI apps. 
                                    Fraudster gains illegal access to mobile phone numbers. 
                                    To mitigate these new fraud scenarios such as SIM Swapping, SIM Jacking and prevent financial losses due to such frauds
                                    National Payments Corporation of India (NPCI) has recently added/modified set of robust security controls.  
                                </p>
                                <div>
                                    <p>
                                        To curb cyber frauds, National Payments Corporation of India (NPCI) has released master circular related to Device and SIM Binding to enhance UPI Apps security
                                        <li>NPCI has mandated checking the SIM or eSIM status on Android and iOS mobiles. App developers are now compelled to integrate SIM or eSIM status checks into their security protocols.</li>
                                        <li>Device binding is not allowed while the device is in Airplane Mode</li>
                                        <li>As per NPCI guidelines, for Android and iOS mobile even if Wi-Fi is available, it permits device binding only when a SIM/e-SIM/telco (telecommunications) connection is available</li>
                                        <li>Device Binding completion in the same session</li>
                                        <li>For Android - NPCI has mandated Android mobile users that they are not allowed to toggle between apps or press any button until the device binding process is completed. The token must be invalidated if a customer moves out of active session. Auto notification pertaining to SMS charges received on customer device during registration shall not be considered as toggling. </li>
                                        <li>For iOS – For iOS mobile users, once the user is redirected to message app and if customer presses cancel or switches to another app, then application should reject the device binding. For any user registration on iOS devices, if time taken for the control to be passed from SMS composer window to application exceeds 5 seconds the customer onboarding PSP shall decline device binding. </li>
                                        <li>Device binding is not allowed if the same short code (token) is received from multiple mobile numbers. </li>
                                        <li>Set the token length to minimum 35 characters with a combination of alphanumeric and special characters. </li>
                                        <li>Block device ID for 24 hours if more than 3 tokens are generated while doing registration for device binding. </li>
                                        <li>Allow device binding registration only through the latest app version.  </li>
                                        <li>SMS Token Expiry timer should not exceed 45 seconds. </li>
                                        <li>Dynamic SMS token is being created for every registration attempt. </li>
                                        <li>Private API Solution for iOS prevents editing of encrypted token and virtual mobile numbers on SMS body when a user sends SMS to register on iOS. </li>
                                        <li>Customer on-boarding on iOS/Android based Devices is allowed on iPhone devices which supports SMS sent API available from iOS 17 onwards. (Current XR/XS and above devices) and for Android it is allowed from Android API version 23 and above only. </li>
                                        <li>Every UPI App ensures at least 10 Virtual Mobile Numbers. Token should be generated dynamically and sent randomly to one of the unique VMN. VMN’s should not be in series and should not repeat. </li>
                                        <li>Every UPI application or PSP should validate successful sent check of SMS for both iOS and Android devices.  </li>
                                    </p>
                                    <div style="padding-left: 40px;">
                                        <p>
                                            All Payment Service Providers (PSPs) are required to implement <a href="https://www.protectt.ai/appbind">SIM and Device Binding</a> as per National Payments Corporation of India (NPCI) mandate. 
                                            SIM cards and devices add an additional layer of authentication and security. 
                                            It makes SIM Swapping difficult for unauthorized users to access the account and unauthorized transactions.
                                            Implementation of <a  class="anchor-tag" href="https://www.protectt.ai/appbind">SIM and Device Binding</a> is a regulatory requirement, it can help PSPs avoid legal issues and demonstrate their commitment to mobile app security.
                                        </p>
                                        <p>
                                            Read more about AppBind – Protectt.ai’s Zero Trust <a  class="anchor-tag" href="https://www.protectt.ai/appbind">DEVICE & SIM Binding</a> Solution.
                                            Safe and secure mobile banking experience with advance mobile <a  class="anchor-tag" href="https://www.protectt.ai/appbind">DEVICE & SIM binding</a> technique.
                                        </p>
                                        <p>
                                            Key highlights:
                                            <li>Prevents identity frauds (SIM swapping, SMS spoofing, device theft, brute force attacks and social engineering). </li>
                                            <li>Creates a unique digital identity for each mobile app user. </li>
                                            <li>Zero-factor authentication for every app launch. </li>
                                            <li>Eliminate identity theft and frauds like SMS Spoofing  </li>
                                            <li>Step up Authentication using Tokenization.  </li>
                                            <li>Proprietary Tech (LSAP, 3 Way Hairpin) to authenticate phone number and Looping Enhanced User experience – lesser inputs and advance security.  </li>
                                            <li>Available for Android and IOS </li>
                                        </p>
                                    </div>
                                    <b><h2><span
                                        style="color: #da2b27;">To know more and have a detailed demo, please</span> get in touch with us on 
                                        <a  class="anchor-tag" href="sales@protectt.ai">sales@protectt.ai</a></h2></b>
                                        <p><b><span
                                        style="color: #163e6f;">Protectt.</span><span
                                        style="color: #da2b27;">ai</span></b>  is ‘A Leader in Mobile App Security in India.’ Built India’s first SaaS-based, Innovative Mobile App Security platform with Runtime Application Self Protection capabilities.
                                        Protectt.ai is delivering the next generation Mobile App, Device & Transaction Security Platform with 50+ 
                                        Mobile App Security features driven by Deep Tech. </p>
                                        <p>For more information, please visit: <a  class="anchor-tag" href=" https://protectt.ai/"> https://protectt.ai/</a> </p>
                                       
                                        <p>Official LinkedIn account:<a  class="anchor-tag" href=" https://www.linkedin.com/company/protectt-ai-labs-pvt-ltd/ ">https://www.linkedin.com/company/protectt-ai-labs-pvt-ltd/ </a> </p>
                                   <h3>Contact us: 8850106650, Email us: sales@protectt.ai</h3>
                                        <!-- <h3><span style="color: #163e6f;">App</span><span
                                        style="color: #da2b27;">Protectt</span> is ‘A Leader in Mobile App Security in India.’</h3>
                                    <p>
                                        <a class="anchor-tag"
                                        [routerLink]="['/appprotectt']">AppProtectt</a> by <span
                                                style="color: #163e6f;">Protectt</span><span
                                                style="color: #da2b27;">ai</span> Built India’s first SaaS-based, Innovative Mobile App Security platform with Runtime Application Self Protection capabilities. 
                                                <span
                                                style="color: #163e6f;">Protectt</span>
                                                <span
                                                style="color: #da2b27;">ai</span> is delivering the next generation Mobile App, Device & Transaction Security Platform with 50+ Mobile App Security features driven by Deep Tech. 
                                    </p> -->
                                    
                                </div>
                            </div>
                        </div>
                        <!-- blog-details-wrapper end -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- content-wraper end -->

</main>